import slice, {
    fetchScheduleByCartId,
    getPickupSchedule,
    setSchedule,
    resetSchedule,
} from './pickup.slice';
export { fetchScheduleByCartId, getPickupSchedule, setSchedule, resetSchedule };
export default slice.reducer;
